export default "__VITE_ASSET__BuOx0sJ7__$_?url__"